import { TextField } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { EntryWithRelated } from '../../models/inspections'
import { useUpdateInspectionEntryMutation } from '../../redux/api/inspectionApi'
import { LoadingWrapper } from '../SharedUI/LoadingWrapper'

export const CustomerNotesField = ({
  entry,
  customerNotesLoading,
  setCustomerNotesLoading
}: {
  entry: EntryWithRelated
  customerNotesLoading: boolean
  setCustomerNotesLoading: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const [updateEntry] = useUpdateInspectionEntryMutation()
  const [customerNotes, setCustomerNotes] = useState(
    entry.info?.customerNotes || ''
  )
  useEffect(() => {
    setCustomerNotes(entry.info?.customerNotes || '')
  }, [entry.info])
  const { accessToken } = useAccessTokenAndShopId()
  const updateNotes = useCallback(
    async (customerNotes: string) => {
      setCustomerNotesLoading(true)
      await updateEntry({
        authorization: accessToken,
        entryEntry: {
          ...entry,
          info: {
            ...entry.info!,
            customerNotes
          }
        }
      })
      setCustomerNotesLoading(false)
    },
    [accessToken, entry, setCustomerNotesLoading, updateEntry]
  )
  return (
    <LoadingWrapper loading={customerNotesLoading}>
      <TextField
        sx={{ mt: 2, height: '100%' }}
        fullWidth
        value={customerNotes}
        onChange={(event) => setCustomerNotes(event.target.value)}
        onBlur={(event) => updateNotes(event.target.value)}
        multiline
        minRows={3}
        disabled={customerNotesLoading}
      />
    </LoadingWrapper>
  )
}
